(function () {
    "use strict";

    angular.module("app").component("habilActionsButton", {
        template: `
        <div class="btn-group">
            <button class="btn"
                    ng-class="$ctrl.buttonClass"
                    type="button"
                    ng-click="$ctrl.actions[0].execute()"
                    ng-disabled="$ctrl.isDisabled"
                    i18n="{{$ctrl.actions[0].label}}">
            </button>
            <button type="button"
                    ng-if="$ctrl.actions.length>1"
                    class="btn dropdown-toggle dropdown-toggle-split"
                    ng-class="$ctrl.buttonClass"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    ng-disabled="$ctrl.isDisabled">
                <span class="fa fa-caret-down">&nbsp;</span>
            </button>
            <div class="dropdown-menu" ng-if="$ctrl.actions.length>1">
                <button class="dropdown-item"
                        ng-repeat="action in $ctrl.actions | limitTo: 1 - $ctrl.actions.length"
                        ng-disabled="$ctrl.isDisabled"
                        ng-click="action.execute()"
                        i18n="{{action.label}}">
                </button>
            </div>
        </div>`,
        bindings: { actions: "<", buttonClass: "@", isDisabled: "<", }
    });
})();
